<template>
  <no-results
    :icon="getIcon(file.file_extension)"
    :title="file.file_name"
    subtitle="No preview to display"
  >
    <q-btn
      icon="mdi-download-outline"
      class="q-mt-md"
      size="12px"
      no-caps
      color="blue-6"
      label="Download File"
      @click="goToHref(file.signed_url)"
    />
  </no-results>
</template>

<script>
import typeMixin from './mixin'
import fileMixin from '../../mixins/fileMixin'

export default {
  mixins: [typeMixin, fileMixin]
}
</script>
